import { onAuthStateChanged, getIdToken } from 'firebase/auth';

import http from './utilities/http';
import { auth } from './services/firebaseAuth';
import { logout, verifyToken } from './services/auth';
import * as interceptors from './commons/interceptors';
import { getAccessToken, clear, setAccessToken } from './services/token';
import { setCurrentUser, getCurrentUser } from './services/auth';
import {
  getAllContacts,
  getAllContracts,
  setContacts,
  setContactsAndContracts,
  setContracts,
} from './services/contactAndContract';
import { redirectToHome, redirectToAdmin } from './utilities/auth';

/**
 * Initialize interceptors for the application.
 */
function initInterceptors() {
  http.interceptors.request.use(interceptors.requestInterceptor);
  http.interceptors.response.use(
    (response) => response,
    /**
     * This interceptor checks if the response had a 401 status code, which means
     * that the access token used for the request has expired. It then refreshes
     * the access token and resends the original request.
     */
    interceptors.responseInterceptor
  );
}

/**
 * Resolve local variables like contract, contacts
 */
export async function resolveLocalVariables() {
  try {
    let contactsAndContracts = [];

    let contacts = await getAllContacts().then((response) => {
      if (response?.data?.contact) {
        return response.data.contact;
      } else {
        return [];
      }
    });

    let contracts = await getAllContracts().then((response) => {
      if (response?.data?.contract) {
        return response.data.contract;
      } else {
        return [];
      }
    });

    /**
     * Save contacts and contracts to localstorage.
     */
    if (contacts && (contacts || []).length) {
      setContacts(contacts);
      contactsAndContracts = contacts;
    }

    if (contracts && (contracts || []).length) {
      setContracts(contracts);
      contactsAndContracts = [...contactsAndContracts, ...contracts];
    }

    //save combined contacts and contracts
    setContactsAndContracts(contactsAndContracts);
  } catch (err) {
    console.log(err);
  }
}

/**
 * Attach firebase auth observer to the global authentication object
 */
function attachAuthObserver() {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      // User is signed in, see docs for a list of available properties
      // https://firebase.google.com/docs/reference/js/firebase.User

      getIdToken(user).then((token) => {
        // Set the access token in the local storage if it is verified not set already
        if (getAccessToken() !== token) {
          clear();
          verifyToken(token)
            .then((response) => {
              const { role, account_type } = response.data;
              setAccessToken(token);
              setCurrentUser({ ...user, role, account_type });

              // Redirect to home page if user is authenticated.
              if (!!getAccessToken()) {
                const user = getCurrentUser();
                // resolve contracts and contacts and store in local storage
                resolveLocalVariables();
                if (user.role === 'super_admin') {
                  redirectToAdmin();
                } else {
                  redirectToHome();
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          // Redirect to home page if user is authenticated.
          const user = getCurrentUser();
          // resolve contracts and contacts and store in local storage
          (user && user.role !== 'super_admin') && resolveLocalVariables();
          if (user.role === 'super_admin') {
            redirectToAdmin();
          } else {
            redirectToHome();
          }
        }
      });
    } else {
      clear();
      logout();
    }
  });
}

export default function init() {
  // attachAuthObserver();
  initInterceptors();
}
